import { type transformThemeConfigToCSSVariables } from "@/utils/theme/transformThemeConfigToCSSVariables";
import type { Device } from "@/types/theme";

type CSSVariables = ReturnType<typeof transformThemeConfigToCSSVariables>;

export function getCSSVariablesByDevice(
  variables: CSSVariables,
  device: Device,
): CSSVariables {
  return Object.keys(variables).reduce((acc, current) => {
    const suffix = `-${device}`;

    if (current.endsWith(suffix)) {
      acc[current.replace(suffix, "")] = variables[current];
    }

    return acc;
  }, {} as CSSVariables);
}

export function getCSSVariablesWithoutDevice(variables: CSSVariables) {
  const devices: Device[] = ["mobile", "tablet", "desktop"];

  return Object.keys(variables).reduce((acc, current) => {
    const regExp = new RegExp(`-(${devices.join("|")})$`);

    if (!regExp.test(current)) {
      acc[current] = variables[current];
    }

    return acc;
  }, {} as CSSVariables);
}
